"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypeToFocus = exports.default = void 0;
var _isPrintableKeyEvent = _interopRequireDefault(require("is-printable-key-event"));
var _keycode2 = _interopRequireDefault(require("../keycode/keycode"));
var _useKeyStrokes2 = require("./useKeyStrokes");
var useTypeToFocus = exports.useTypeToFocus = function useTypeToFocus(_ref) {
  var _ref$focusCandidates = _ref.focusCandidates,
    focusCandidates = _ref$focusCandidates === void 0 ? [] : _ref$focusCandidates,
    _ref$keyStrokeTimeout = _ref.keyStrokeTimeout,
    keyStrokeTimeout = _ref$keyStrokeTimeout === void 0 ? 50 : _ref$keyStrokeTimeout,
    _ref$useSpaces = _ref.useSpaces,
    useSpaces = _ref$useSpaces === void 0 ? false : _ref$useSpaces,
    focusMatchingItem = _ref.focusMatchingItem;
  var _useKeyStrokes = (0, _useKeyStrokes2.useKeyStrokes)({
      keyStrokeTimeout: keyStrokeTimeout,
      onKeyStrokes: function onKeyStrokes(typedString) {
        return focusMatchingItem(typedString, focusCandidates);
      }
    }),
    keyStrokes = _useKeyStrokes.keyStrokes,
    setKeyStrokes = _useKeyStrokes.setKeyStrokes;
  var handleTypeToFocus = function handleTypeToFocus(event) {
    if (!event.ctrlKey && !event.metaKey && (0, _isPrintableKeyEvent.default)(event)) {
      var _keycode, _keycode$replace;
      event.stopPropagation();
      var nextKeyStroke = ((_keycode = (0, _keycode2.default)(event)) === null || _keycode === void 0 || (_keycode$replace = _keycode.replace) === null || _keycode$replace === void 0 ? void 0 : _keycode$replace.call(_keycode, 'numpad ', '')) || '';
      setKeyStrokes(keyStrokes + nextKeyStroke);
    } else if (useSpaces && (0, _keycode2.default)(event) === 'space') {
      setKeyStrokes("".concat(keyStrokes, " "));
    }
  };
  return {
    handleTypeToFocus: handleTypeToFocus
  };
};
var _default = exports.default = useTypeToFocus;